import css from './frame.module.scss';

import { memo } from 'react';

type TProps = {
  children: React.ReactNode;
};

const WaitTimer = ({ children }: TProps) => {
  return <div className={css.waitTimer}>{children}</div>;
};

export default memo(WaitTimer);
